export var FileGenerationStatus;
(function (FileGenerationStatus) {
    FileGenerationStatus["Idle"] = "file-generation-status_idle";
    FileGenerationStatus["Fetching"] = "file-generation-status_fetching";
    FileGenerationStatus["Collecting"] = "file-generation-status_collecting";
    FileGenerationStatus["Generating"] = "file-generation-status_generating";
    FileGenerationStatus["Generated"] = "file-generation-status_generated";
    FileGenerationStatus["Downloading"] = "file-generation-status_downloading";
    FileGenerationStatus["Zipping"] = "file-generation-status_zipping";
    FileGenerationStatus["Error"] = "file-generation-status_error";
})(FileGenerationStatus || (FileGenerationStatus = {}));
export var FileGenerationType;
(function (FileGenerationType) {
    FileGenerationType["ReportSocialPackage"] = "report-social-package";
    FileGenerationType["ReportSocialProject"] = "report-social-project";
    FileGenerationType["LabourHourExport"] = "labour-hour-export";
    FileGenerationType["ReportExportConfig"] = "report-export-config";
    /** A ZIP of the documents filed against one adopted framework (issue #30). */
    FileGenerationType["FrameworkEvidencePack"] = "framework-evidence-pack";
})(FileGenerationType || (FileGenerationType = {}));
export var ReportExportScope;
(function (ReportExportScope) {
    ReportExportScope["Project"] = "project";
    ReportExportScope["Package"] = "package";
    /** Across the organisation's projects, combined and broken down by project. */
    ReportExportScope["Organisation"] = "organisation";
})(ReportExportScope || (ReportExportScope = {}));
export const DEFAULT_CSV_EXPORT_OPTIONS = {
    includeHeaderRow: true,
    includeTotalsRow: false
};
export const DEFAULT_EXPORT_OPTIONS = {
    includeCsv: true,
    includeEnvironmental: true,
    includeLabourHours: true,
    includeLocalContent: true,
    includePdf: true,
    includeSocialSpend: true
};
